import { useTranslation } from 'react-i18next';
import { castArray, isEmpty } from 'lodash/fp';
import { Defaults } from 'app/lib/constants';
import * as styles from './FieldError.css';

export interface FieldErrorProps {
    messages?: string | string[];
}

export function FieldError({ messages = Defaults.ARRAY }: FieldErrorProps) {
    const { t } = useTranslation();

    if (isEmpty(messages)) {
        return null;
    }

    return (
        <ul className={styles.base} data-testid="field-error">
            {castArray(messages).map((msg) => (
                <li key={msg}>{t(msg)}</li>
            ))}
        </ul>
    );
}
